/* eslint-disable */
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import {
  DeleteTraining,
  ViewSponsorsDet,
} from "../../../../api/AuthenticationServices";

const ViewSponsors = (props) => {
  const theme = useTheme();
  const [records, setRecords] = useState([]);
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
    },
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    console.log(config);
    try {
      const res = await ViewSponsorsDet(config);
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", records);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }
  const columns = [
    {
      field: "name",
      headerName: "Sponsor Name",
      cellClassName: "name-column--cell",
    },

    {
      field: "delete",
      headerName: "Delete",
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          startIcon={<DeleteIcon />}
          onClick={() => handleDelete(params.row)}
        >
          Delete
        </Button>
      ),
    },
  ];

  const handleDelete = async (row) => {
    // Handle delete button click event here

    try {
      const deleteData = {
        headers: config.headers,
        data: {
          deleteId: row.id,
        },
      };
      const delRes = await DeleteTraining(deleteData);
      if (delRes.data.status === "success") {
        alert(delRes.data.message);
      } else {
        alert(delRes.data.message);
      }
    } catch (error) {
      alert(error.message);
    }
    navigate("/admin/viewsponsors");
  };
  return (
    <Box m="20px">
      <Header title="SPONSORS" subtitle="List of sponsor details" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={records}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

export default ViewSponsors;
